<app-modal #errorModal>
  <div class="modal-content">
    <div class="modal-header border-0">
      <h5 class="modal-title" i18n="@@error-modal.title">Error</h5>
    </div>
    <div class="modal-body" i18n="@@error-modal.message">
      Something went wrong, you will be log out in {{ redirectCountdown }} seconds.
    </div>
    <div class="modal-footer text-center border-0 rounded-bottom">
      <button type="button" class="btn btn-primary" (click)="logOut()" i18n="@@student-menu.logout">Logout</button>
    </div>
  </div>
</app-modal>